<template>
    <div>
        <b-navbar toggleable="lg" type="light" variant="light" fixed="top">
            <b-navbar-brand href="#"><router-link :to="{name: 'Home'}">StationaryShop</router-link></b-navbar-brand>
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav v-if="$store.state.loginStatus">
                    <b-nav-item href="#" class="ml-2" ><i class="fas fa-shopping-cart"></i><router-link :to="{name: 'Cart'}">my-Cart</router-link></b-nav-item>
                    <b-nav-item href="#" class="ml-2" ><i class="fas fa-file-invoice-dollar"></i><router-link :to="{name: 'Transaction'}">my-Transaction</router-link></b-nav-item>
                </b-navbar-nav>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-button v-if="!$store.state.loginStatus" v-b-modal.modal-1 type="button" variant="outline-primary mr-2">Login</b-button>
                    <b-button v-if="!$store.state.loginStatus" type="button" @click="toRegister" variant="primary">Register</b-button>
                    <b-nav-item-dropdown v-if="$store.state.loginStatus" right>
                    <!-- Using 'button-content' slot -->
                        <template v-slot:button-content>
                            <em>Hello, {{$store.state.name}}</em>
                        </template>
                        <b-dropdown-item @click="doLogout">Log Out</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
import swal from 'sweetalert'

export default {
    name: 'Navbar',
    methods: {
        doLogout() {
            swal({
                title: 'Do you want Logout?',
                buttons: true,
                dangerMode: true,
                closeOnClickOutside: false,
            })
            .then(confirm=>{
                if(confirm){
                    localStorage.clear()
                    this.$store.dispatch('logout')
                    swal('See you!','Logout success','success')
                    this.$router.replace({name:'Home'})
                }
            })
        },
        toRegister() {
            this.$router.push({name:'Register'})
        }
    },
}
</script>